module.exports = __webpack_public_path__ + "static/img/Max-Gawn.4bfe84e.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Max-Gawn.jpg
// module id = C8m4
// module chunks = 0